import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { CENTRAL_DOMAIN_API_URL } from '../constants/constants';
import { Box } from '@mui/system';
import { CircularProgress, Fade, LinearProgress } from '@mui/material';
import MinimalLayout from '../layout/MinimalLayout';
import { toast } from 'react-toastify';


// Crear el contexto
export const TenantContext = createContext({});

const useTenantConfig = () => {
    return useContext(TenantContext);
}



// Proveedor del contexto
export const TenantProvider = ({ children }) => {
    const [loading, setLoading] = useState(true); // Estado de carga
    const [tenantConfig, setTenantConfig] = useState(null);
    const [apiUrl, setApiUrl] = useState(null);
    // const [apiUrl, setApiUrl] = useState('http://stellantis.localhost:8000'); //dev
    // const [apiUrl, setApiUrl] = useState('https://xymview-core-backend-h9b8a6h3cggvbtgc.spaincentral-01.azurewebsites.net'); //prod

    // Cargar la configuración desde el localStorage al iniciar
    useEffect(() => {
        const storedConfig = localStorage.getItem('XymviewTenantConfig');
        if (storedConfig) {
            setTenantConfig(JSON.parse(storedConfig));
            console.info('Founded cached tenant config, restoring it...');
            setLoading(false); // Si ya hay config en el localStorage, dejamos de mostrar la UI de carga
        }

        fetchTenantConfig(); // Refrescamos de todas formas la config del tenant desde el backend
    }, []);

    useEffect(() => {
        if (tenantConfig) {
            // Guardar en localStorage solo si la configuración ha cambiado
            const storedConfig = JSON.parse(localStorage.getItem('XymviewTenantConfig'));
            if (JSON.stringify(tenantConfig) !== JSON.stringify(storedConfig)) {
                localStorage.setItem('XymviewTenantConfig', JSON.stringify(tenantConfig));
            }


            // Actualizar apiUrl solo si es diferente
            if (tenantConfig.api_url !== apiUrl) {
                setApiUrl(tenantConfig.api_url);
            }
        }
    }, [tenantConfig, apiUrl]);

    const fetchTenantConfig = async () => {
        try {
            if (tenantConfig) {
                setLoading(true);
            }
            // Crear un objeto de cabeceras (headers)
            const headers = new Headers();

            // Solo añadir el header 'Tenant-domain' si estamos en desarrollo local
            // if (window.location.hostname === 'localhost' || window.location.hostname.endsWith('.localhost')) {
            //     headers.append('Tenant-Domain', window.location.hostname);
            // }
            headers.append('Tenant-Domain', window.location.hostname);


            let response = await fetch(`${CENTRAL_DOMAIN_API_URL}/api/tenant/config`, {
                method: 'get',
                headers: headers,
            });

            if (!response.ok) {
                const message = `An error has occurred: ${response.status}`;
                throw new Error(message);
            }

            response = await response.json();

            if (response.error) throw new Error(response.message);

            // console.info(JSON.stringify(tenantConfig))
            // console.info(JSON.stringify(response.config))
            const storedConfig = localStorage.getItem('XymviewTenantConfig');

            if (JSON.stringify(response.config) !== storedConfig) {
                setTenantConfig(response.config);
                if (storedConfig){
                    toast.info('La configuración del cliente ha cambiado, refrescando datos...')
                }
            }
            console.info('Tenant fresh config retrieved successfully');
        } catch (error) {
            console.error('Error de red al cargar la configuración del tenant:', error);
        } finally {
            setLoading(false);
        }
    };

    // Memorizar el valor del contexto
    const memoedValue = useMemo(
        () => ({
            tenantConfig,
            apiUrl,
        }),
        [tenantConfig, apiUrl]
    );

    return (
        <TenantContext.Provider value={memoedValue}>
            <Fade in={!loading} mountOnEnter unmountOnExit>
                <Box>
                    {children}
                </Box>
            </Fade>
            <Fade in={loading} mountOnEnter unmountOnExit>
                <Box
                    display="flex"
                    width={"100%"}
                    height={"100%"}
                    alignItems="start"
                    justifyContent="start"
                    style={{ backgroundColor: '#f3f3f3', height: '100vh' }}
                >
                    {/*<CircularProgress variant={"indeterminate"} color={'primary'} />*/}
                    <LinearProgress variant={"indeterminate"} color={'primary'} sx={{width: '100%', height: '6px'}}/>
                </Box>
            </Fade>
        </TenantContext.Provider>
    );
};
